export default __webpack_public_path__ + "static/media/arrow-yellow.56d78f1a.svg";